import { FC, useState, useEffect, useMemo } from "react";
import StatusLegendComponent from "../../../../../../common/components/status-legend/status-legend.component";
import billingsCargoOrderListingHelper from "../billings-cargo-order-listing.helper";
import MetaBillingsCargoTaxiStatusCounters from "../../../../../../common/services/meta/billings/cargo-taxi/status-counters/meta-billings-cargo-taxi-status-counters";
import useMetaBillingsCargoTaxiStatusCounters from "../../../../../../common/services/meta/billings/cargo-taxi/status-counters/use-meta-billings-cargo-taxi-status-counters";
import useAbort from "../../../../../../common/hooks/use-abort";
import MetaBillingsCargoTaxiStatusCountersParams from "../../../../../../common/services/meta/billings/cargo-taxi/status-counters/meta-billings-cargo-taxi-status-counters-params";
import BillingsCargoOrderListingItemBillingStatus from "../types/billings-cargo-order-listing-item-billing-status";

type BillingsCargoOrderListingStatusLegendProps = {
  cargoCompanyUuid: string | null;
  visibleStatuses?: BillingsCargoOrderListingItemBillingStatus[];
};

const BillingsCargoOrderListingStatusLegendComponent: FC<
  BillingsCargoOrderListingStatusLegendProps
> = (props) => {
  const [statusCount, setStatusCount] = useState<
    MetaBillingsCargoTaxiStatusCounters | undefined
  >();

  const metaBillingsCargoTaxiStatusCounters =
    useMetaBillingsCargoTaxiStatusCounters();
  const metaBillingsCargoTaxiStatusCountersAbort = useAbort();

  useEffect(() => {
    const params: MetaBillingsCargoTaxiStatusCountersParams = {
      cargoCompanyId: props.cargoCompanyUuid!,
    };

    metaBillingsCargoTaxiStatusCounters.load(
      params,
      metaBillingsCargoTaxiStatusCountersAbort.signal,
    );

    return metaBillingsCargoTaxiStatusCountersAbort.revoke;
  }, [props.cargoCompanyUuid]);

  useEffect(() => {
    if (!metaBillingsCargoTaxiStatusCounters.data) {
      return;
    }
    setStatusCount(metaBillingsCargoTaxiStatusCounters.data);
  }, [metaBillingsCargoTaxiStatusCounters.data]);

  const statusOptions = useMemo(() => {
    if (!props.visibleStatuses || props.visibleStatuses.length === 0) {
      return [];
    }

    let options = billingsCargoOrderListingHelper.getStatusOptions(statusCount);

    options = options.filter((option) =>
      props.visibleStatuses!.includes(
        option.status as BillingsCargoOrderListingItemBillingStatus,
      ),
    );

    return options;
  }, [statusCount, props.visibleStatuses]);

  return <StatusLegendComponent statusData={statusOptions} />;
};

export default BillingsCargoOrderListingStatusLegendComponent;
